import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RefillRequest } from '../Models/refillrequest.model';

@Injectable({
  providedIn: 'root',
})
export class RefillRequestService {
  url = environment.Url + 'RefillRequests';

  header = new HttpHeaders({
    Authorization: 'token' + localStorage.getItem('token'),
  });

  constructor(private http: HttpClient) {}

  registerRefillRequest(body) {
    return this.http
      .post<RefillRequest>(this.url, body)
      .pipe(catchError(this.handleError));
  }

  getRefillRequests() {
    return this.http
      .get<RefillRequest[]>(this.url)
      .pipe(catchError(this.handleError));
  }
  getRefillRequestById(id) {
    return this.http.get<RefillRequest>(this.url + '/' + id);
  }

  updateRefillRequest(id, body) {
    return this.http
      .put<RefillRequest>(this.url + '/' + id, body)
      .pipe(catchError(this.handleError));
  }

  deleteRefillRequest(id) {
    return this.http
      .delete<RefillRequest>(this.url + '/' + id)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error);
        return throwError(error.error);
      } else if (error.status == 401) {
        return throwError('invalid username or password');
      } else if (error.status == 0) {
        return throwError('network failure please try again later ');
      }
      return throwError(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}
